import React, { useEffect, useState } from 'react';
import {Grid, Box, Modal, Typography, Button, FormControl, LinearProgress, TextField} from "@mui/material";
import { styles } from "./styles";
import CloseIcon from '@mui/icons-material/Close';
import MuiSelect from "components/MuiSelect/MuiSelect";
import { getRolePermissions, addRoleApi } from "apis/user";
import SwitchGroup from './SwitchGroup';
import { Colors } from 'assets/colors';
import CommonUtil from "../../../common/CommonUtil";
import TruckMuiSelect from "../../MuiSelect/TruckMuiSelect";
import ToastManager from "../../../common/ToastManager";
import {removeFalseItems} from "./commonUtil";

interface AddRoleProps {
  open: boolean;
  handleClose: Function | any;
  getRoles: Function;
}

interface InputType {
  type: string,
  placeholder: string,
  disabled?: boolean,
  label?: string,
  size: number,
  value: string | undefined,
  key: string
}

interface SelectType {
  size: number,
  options: Array<string>,
  value: any,
  key?: string,
  onChange: any
}

var CONFIGURATION_MANAGER = "Configuration Manager";
var VISION = "Vision";

const AddRoleModal: React.FC<AddRoleProps> = ({ open, handleClose, getRoles }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [permissions, setPermissions] = useState<any>([]);
  const [productOptions, setProductOptions] = useState([]);
  const [currentProduct, setCurrentProduct] = useState("");
  const [roleName, setRoleName] = useState("");
  const [roleNameErr, setRoleNameErr] = useState(true);


  const [roleDescription, setRoleDescription] = useState("");
  const [filtered, setFiltered] = useState<any>([]);
  const [modules, setModules] = useState<any>([]);
  const [err, setErr] = useState("");
  const [disabledPageIds, setDisabledPageIds] = useState<any>([]);
  const [disabledModuleIds, setDisabledModuleIds] = useState<any>([]);
  const [currentStatus, setCurrentStatus] = useState("Active");

  const [truckStatuses,setTruckStatuses] = useState<any>(CommonUtil.statuses);
  const [status,setStatus] = useState<any>(null);
  const [statusError,setStatusError] = useState(true);

  const handleAddRole = async () => {
    //if (roleName !== "") {
    if(!roleName && !status){
      setRoleNameErr(true);
      setStatusError(true);
    }else if(!roleName){
      setRoleNameErr(true);
    }else if(!status){
      setStatusError(true);
    }else if(roleName && status){
      if(roleName.length > 64) {
        setErr("Role name can only contain 64 characters.");
        return
      }
      if(roleDescription.length > 128) {
        setErr("Role description can only contain 128 characters.");
        return
      }
      let finalPermissions = [...filtered];
      // if (disabledModuleIds.length > 0) {
      //   finalPermissions = finalPermissions.filter((f: any) => !disabledModuleIds.includes(f.moduleName))
      // }
      // if (disabledPageIds.length > 0) {
      //   finalPermissions = finalPermissions.filter((f: any) => !disabledPageIds.includes(f.masterPermissionId))
      // }

      let newPermissions: any = finalPermissions.map((f: any) => {
        return {
          masterPermissionId: f.masterPermissionId,
          canAdd: f.canChecked !== undefined ? f.canChecked : false,
          canEdit: f.canEdit !== undefined ? f.canEdit : false,
          // canDelete: f.canDelete !== undefined ? f.canDelete : f.deletePermission,
        }
      })
      let submitObj = {
        applicationName: currentProduct,
        roleName: roleName,
        roleStatus: status?status.value:"",
        rolePermissions: removeFalseItems(newPermissions),
        roleDescription: roleDescription
      }
      setIsLoading(true);
      console.log(submitObj);
      let data = await addRoleApi(submitObj);
      if (data?.response?.data?.errorMessage) {
        setIsLoading(false);
        ToastManager.showToast(data.response.data.errorMessage,"Error");
        //setErr(data.response.data.errorMessage);
        return
      }
      if (data) {
        setIsLoading(false);
        getRoles();
        handleClose();
        ToastManager.showToast("Role Created Successfully","Success");
      }
    }

    /*}
    else {
      setErr("Role name is required.")
    }*/
  }
  

  const getPermissions = async () => {
    setIsLoading(true);
    let data = await getRolePermissions();
    if (data) {
      setPermissions(data);
      let products = data.map((p: any) => p.applicationName);
      const onlyUnique = (value: any, index: number, self: any) => {
        return self.indexOf(value) === index;
      }
      let uniqueProducts = products.filter(onlyUnique);
      setProductOptions(uniqueProducts);
      console.log(uniqueProducts);
      setCurrentProduct(uniqueProducts[0]);
      setIsLoading(false);
    }
  }

  useEffect(() => {
    getPermissions();
  }, []);

  useEffect(() => {
    //console.log(filtered);
    if (currentProduct !== "" && permissions.length > 0) {
      let filterData = permissions.filter((p: any) => p.applicationName === currentProduct);
      /*filterData.forEach((item:any,idx:number)=>{
        let masterData = getFilterDataPermissions(item.masterPermissionId);
        console.log(masterData);
      });*/
      setFiltered(filterData);
      let modules: any = [];
      for (let i = 0; i < filterData.length; i++) {
        if (!modules.includes(filterData[i].moduleName)) {
          modules.push(filterData[i].moduleName);
        }
      }
      setModules(modules);
    }
  }, [currentProduct, permissions]);

  let getFilterDataPermissions = (masterId:string):any=>{
    let filters = filtered;
    for(let i:number = 0;i<filters.length;i++){
      if(filters[i].masterPermissionId == masterId){
        return filters[i];
      }
    }
    return  null;
  }

  const handleRoleNameChange = (val: string, key: string) => {
    if (key === "name") {
      setRoleName(val);
    }
    if (key === "description") {
      setRoleDescription(val);
    }
    if (err !== "") {
      setErr("");
    }
  }

  const returnInput = (params: InputType) => {
    let { type, placeholder, disabled, label, value, key } = params;
    return (
      <Grid item xs={params.size} sx={styles.inputContainer}>
        {label && <Typography sx={styles.label}>{label}</Typography>}
        {type === "input" ?
          <>
            <input
              type="text"
              placeholder={placeholder}
              style={{ ...styles.input}}
              disabled={disabled ? disabled : false}
              value={value}
              onChange={(e: any) => handleRoleNameChange(e.target.value, key)}
            />
          </>
          :
          <textarea style={styles.textarea} placeholder={placeholder}></textarea>
        }
      </Grid>
    )
  }

  const returnSelect = (params: SelectType) => {
    let { size, value, options, onChange } = params;
    return (
      <Grid item xs={size} sx={{ marginBottom: 0 }}>
        <MuiSelect
          value={value}
          options={options}
          onChangeHandler={(val: any) => onChange(val)}
        />
      </Grid>
    )
  };


  const updateRoleList = (id: number, updatedProperties: any) => {
    console.log(updatedProperties.canEdit);
    let list = [...filtered];
    for (let i = 0; i < list.length; i++) {
      if (list[i].masterPermissionId === id) {
        // Update the object with the matching id
        list[i] = {
          ...list[i],
          canChecked: true,
          ...updatedProperties,
        };
      }
    }
    setFiltered(list);
  };

  const updatePageRoleList = (id: number, value: boolean) => {
    if (value === false) {
      setDisabledPageIds([...disabledPageIds, id]);
    } else {
      let remove = [...disabledPageIds];
      remove.splice(remove.indexOf(id), 1);
      setDisabledPageIds(remove);
    }
    let list = [...filtered];
    for (let i = 0; i < list.length; i++) {
      if (list[i].masterPermissionId === id) {
        // Update the object with the matching id
        list[i] = {
          ...list[i],
          canChecked: value,
          canEdit:(value?true:false)
        };
      }
    }
    setFiltered(list);
  };

  const updateModuleRoleList = (module: string, value: boolean) => {
    if (value === false) {
      setDisabledModuleIds([...disabledModuleIds, module]);
    } else {
      let remove = [...disabledModuleIds];
      remove.splice(remove.indexOf(module), 1);
      setDisabledModuleIds(remove);
    }
    let list = [...filtered];
    for (let i = 0; i < list.length; i++) {
      if (list[i].moduleName === module) {
        // Update the object with the matching id
        list[i] = {
          ...list[i],
          masterPermissionId: list[i].masterPermissionId,
          canAdd: value,
          canEdit: value,
          // canDelete: value,
        };
      }
    }
    setFiltered(list);
  }

  let onChangeRoleName = (e:any)=>{
    setRoleName(e);
    if(e){
      setRoleNameErr(false);
    }else{
      setRoleNameErr(true);
    }
  }
  let onChangeStatus = (data:any)=>{
    setStatus(data);
    if(data){
      setStatusError(false);
    }else{
      setStatusError(true);
    }
  }

  let onChangeDescription = (e:any)=>{
    setRoleDescription(e);
  }

  return (
    <Modal open={open} onClose={handleClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
      <>
        <Box sx={styles.container}>
          {isLoading && <LinearProgress sx={{ margin: ".5rem 0" }} />}
          <Grid item xs={12} sx={styles.header}>
            <h2>Add Role</h2>
            <CloseIcon onClick={() => handleClose(false)} />
          </Grid>
          <Grid item xs={12}>
          {err && <Typography sx={{color: "red", fontSize: ".7rem"}}>{err}</Typography>}
            <Typography sx={styles.subHeader} style={{fontWeight:"bold",marginTop:"0px",marginBottom:"10px"}}>Role Details</Typography>
            <Grid container spacing={2} sx={styles.subContainer}>
              <Grid item xs={6}>
                <TextField style={{width:"100%",paddingBottom:"0px"}}  label={"Role Name"}  value={roleName} inputProps={{ maxLength: 60 }}
                           onChange={(e) => onChangeRoleName(e.target.value)} required={true} error={roleNameErr} />
              </Grid>
              <Grid item xs={6} sx={{ marginBottom: 0 }}>
                <TruckMuiSelect label={"Status"} sKey={"key"} value={"value"} selectedValue={status}  dataSource={truckStatuses}
                                mandatory={true} iserror={statusError} onChangeHandler={(e: any) => onChangeStatus(e)} />
              </Grid>
              {/*returnInput({ type: "input", placeholder: "Role Name", size: 6, value: roleName, key: "name" })*/}
              {/*returnSelect({ size: 6, options: ["Active", "Inactive"], value: currentStatus, onChange: setCurrentStatus })*/}
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <Grid item xs={12} sx={{ marginBottom: 0 }}>
              <TextField style={{width:"100%",paddingBottom:"0px"}}   label={"Role Description"}  inputProps={{ maxLength: 120 }} value={roleDescription}
                         onChange={(e) => onChangeDescription(e.target.value)} required={false} error={false} multiline={true} />
            {/*returnInput({ type: "input", placeholder: "Role Description", size: 12, value: roleDescription, key: "description" })*/}
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <Typography sx={styles.subHeader}>Choose application and pages the role can view and access</Typography>
            <Grid container spacing={2} sx={styles.subContainer}>
              {currentProduct !== "" &&
                returnSelect({ size: 12, options: productOptions, value: currentProduct, onChange: setCurrentProduct })
              }
            </Grid>
          </Grid>

          <Grid item xs={12} style={{display:(currentProduct == CONFIGURATION_MANAGER?"":"none")}}>
            {modules.length > 0 &&
              modules.map((m: any, i: number) =>
                <SwitchGroup
                  key={i}
                  roleData={m}
                  data={filtered}
                  switchChange={updateRoleList}
                  pageChange={updatePageRoleList}
                  updateModule={updateModuleRoleList}
                />
              )
            }
          </Grid>
          <Grid item xs={12} style={{display:(currentProduct == VISION?"":"none")}}>
            {modules.length > 0 &&
                modules.map((m: any, i: number) =>
                    <SwitchGroup
                        key={i}
                        roleData={m}
                        data={filtered}
                        switchChange={updateRoleList}
                        pageChange={updatePageRoleList}
                        updateModule={updateModuleRoleList}
                    />
                )
            }
          </Grid>
          <Grid item xs={12} sx={styles.buttonContainer}>
            <Button sx={styles.cancelButton} onClick={() => handleClose(false)}>Cancel</Button>
            {CommonUtil.isScreenButtonAvailable(CommonUtil.ROLES,CommonUtil.UPDATE_MODE)?<Button sx={styles.addButton} onClick={() => handleAddRole()}>Add Role</Button>:""}
          </Grid>
        </Box>
      </>
    </Modal>
  )
}

export default AddRoleModal;
